import axios from 'axios'
import { getLocalTimeZone } from '../utils/utils'

export const cancelReservation = async ({
  number,
  pickupStation,
  pickupDate,
  appVersionId,
  lang,
  clientId,
}) => {
  const res = await axios.post(`/reservation-cancel/${number}`,
    {
      pickupDate,
      stationTimeZone: getLocalTimeZone(),
      stationId: pickupStation,
      appVersionId,
      nationality: lang,
      clientId,
    }
  )
  return res.data
}
